import { Project } from '../app/(main)/arbeider/[slug]/page.val';
import { ArbeiderPage } from '../app/(main)/arbeider/page.val';

export function getAllActiveProjects(
  projects: Record<string, Project>,
  arbeiderPage: ArbeiderPage
): Record<string, Project & { order: number }> {
  return Object.fromEntries(
    arbeiderPage.links.map((arbeiderPageProject, i) => {
      const slug = arbeiderPageProject;
      return [slug, { ...projects[slug], order: i }];
    })
  );
}
